<template>
    <v-row no-gutters class="eventRaceList">
      <v-col class="pa-3">
        <RaceItem v-for="(item, index) of listData" :item="item" :key="index" />
      </v-col>
    </v-row>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import RaceItem from "@/components/dashboard/eventDetails/raceList/RaceItem.vue";

export default {
  mixins: [apiCalls],
  components: {
    RaceItem
  },
  data () {
    return {
      listData: []
    };
  },
  computed: {},
  methods: {
    async loadRaceList() {
      const id = this.$route.params.id;
      const response = await this.api("get", `/api/v1/livelaps/promoter/event/${id}/races`);
      const { success, message } = response;
      if(success) {
        const { data } = message;
        this.listData = data.map((item) => {
          return {
            ...item,
            startDate: item.startDay,
            displayOnline: item.displayFlag ? 'Yes' : 'No',
            action: "<i class='far fa-pencil-alt'></i>"
          }
        });
      } else { this.listData = []; }
    } 
  },
  mounted () {
    this.loadRaceList();
  }
}
</script>

